import * as Time from "@/lib/helpers/time";
import * as CountryList from "@/lib/helpers/listHelpers";
import * as ComponentViewController from "@/lib/helpers/componentViewController/index";
import * as Validators from "@/lib/helpers/validators";
import Vue, { Component, ComponentOptions, VueConstructor } from "vue";

type VuexPathMixin = {
  storePath: string;
  getVuexPath(): Set<string>;
} & Vue;

interface IVueMixinsType {
  [k: string]: VueConstructor<Vue>;
}

function castComponent(component: Component) {
  return component as ComponentOptions<Vue>;
}

export { Time, CountryList, ComponentViewController, castComponent, Validators };
